import { Box, Group, ActionIcon, FileButton, Button, Textarea, Text, LoadingOverlay } from '@mantine/core';
import {
  IconTrash,
  IconUpload,
  IconPlus,
} from '@tabler/icons-react';
import { randomId } from '@mantine/hooks';

import { useCreateMethodOptions } from '../../hooks/use-create-method-options';
import { CustomMethodOptionsSelect } from './custom-method-options-select';

import type { UseFormReturnType } from '@mantine/form';
import type { TPaymentMethodDataOption } from '../../store/types';

type Props<T> = {
  form: UseFormReturnType<T, (values: T) => T>;
  items?: TPaymentMethodDataOption[];
};

export function CustomMethodFormOptions<T>(props: Props<T>) {
  const {
    form,
    items,
  } = props;

  const {
    imageNameList,
    file,
    isLoading,
    isSuccess,
    setFile,
    handleAddImage,
  } = useCreateMethodOptions();


  if (isSuccess && file) {
    // form.insertListItem('data.step1.options', { name: '', logo: file.name, key: randomId() });
    form.clearFieldError('data.step1.options');
    setFile(null);
  }

  return (
    <Box maw={500} mx="auto" pos="relative">
      <LoadingOverlay visible={isLoading} zIndex={1000} overlayProps={{ radius: "sm", blur: 2 }} />
      <Text size="sm" fw={700}>Способы оплаты</Text>

      {(items && items.length > 0) && (
        <Group mb="xs">
          <Text fw={300} size="sm" style={{ flex: 2 }}>
            Имя файла
          </Text>
          <Text fw={300} size="sm" pr={40}>
            Платёжная система
          </Text>
        </Group>
      )}

      {(items && items.length > 0 && !isLoading && imageNameList) && items.map((_, index) => (
        <Group key={form.key(`data.step1.options.${index}`)} mt="xs" gap="xs">
          <CustomMethodOptionsSelect
            form={form}
            imageNameList={imageNameList}
            index={index}
          />
          <Textarea
            placeholder="Название"
            withAsterisk
            autosize
            style={{ flex: 2 }}
            key={form.key(`data.step1.options.${index}.name`)}
            {...form.getInputProps(`data.step1.options.${index}.name`)}
          />
          <ActionIcon color="red" onClick={() => form.removeListItem('data.step1.options', index)}>
            <IconTrash size={16} />
          </ActionIcon>
        </Group>
      ))}

      <Group justify="center" mt="md">
        <Button
          variant="default"
          size="xs"
          leftSection={<IconPlus size={12} />}
          loading={isLoading}
          onClick={() => {
            form.insertListItem('data.step1.options', { name: '', logo: '', key: randomId() });
            form.clearFieldError('fields');
          }}
        >
          Добавить способ оплаты
        </Button>
      </Group>

      {form.errors['data.step1.options'] && (
        <Text c="red" size="sm" mt="sm">
          {form.errors['data.step1.options']}
        </Text>
      )}

      <Group justify="center" mt="md">
        <Text size="xs">Если нет подходящей картики банка или платёжной системы, загрузите изображение (.jpeg, .png)</Text>
        <FileButton onChange={handleAddImage} accept="image/png,image/jpeg">
          {(props) => (
            <Button
              size="xs"
              variant="default"
              leftSection={<IconUpload size={12} />}
              loading={isLoading}
              {...props}
            >
              Загрузить картинку
            </Button>
          )}
        </FileButton>
      </Group>
    </Box>
  );
}
